import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import { api } from "@/lib/api";

interface CallActionsMenuProps {
  callId: string;
  onCloneSuccess: () => void;
  disabled?: boolean;
}

export function CallActionsMenu({
  callId,
  onCloneSuccess,
  disabled,
}: CallActionsMenuProps) {
  const handleClone = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click event
    try {
      await api.cloneCall(callId);
      toast({
        title: "Success",
        description: "Call cloned successfully",
      });
      onCloneSuccess();
    } catch (error) {
      console.error("Failed to clone call:", error);
      toast({
        title: "Error",
        description: "Failed to clone call",
        variant: "destructive",
      });
    }
  };

  const handleCopyId = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(callId);
      toast({
        title: "Success",
        description: "Call ID copied to clipboard",
      });
    } catch (error) {
      console.error("Failed to copy call ID:", error);
      toast({
        title: "Error",
        description: "Failed to copy call ID",
        variant: "destructive",
      });
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
        <Button variant="ghost" size="icon" disabled={disabled}>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleClone} data-clone-call-id={callId}>
          Clone Call
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleCopyId}>Copy Call ID</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
